import React from 'react';

export function SkeletonList({ count = 3, cardHeight = '80px' }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skeleton-card" style={{ height: cardHeight }} />
      ))}
    </div>
  );
}
